import { RemoteConnection } from '../../models/dev-box';
import { createStringIdAdapter } from './common/string-id-adapter';

export const remoteConnectionAdapter = createStringIdAdapter<RemoteConnection>();
